import React from "react";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import { ToastProps } from "react-toastify/dist/types";

const NotificationToastBody: React.FC<{
  title?: string;
  textMessages?: string[];
  body?: any;
  image?: string[];
  closeToast?: () => void;
  toastProps?: ToastProps;
}> = ({ title, textMessages, body, closeToast, toastProps }) => {
  return (
    <React.Fragment>
      {textMessages != null || body != null ? (
        <React.Fragment>
          <AlertTitle>{title}</AlertTitle>

          {textMessages != null &&
            textMessages.map((m, i) => (
              <Typography key={i} variant="body2">
                {m}
              </Typography>
            ))}
          {body != null && <Typography variant="body2">{body}</Typography>}
        </React.Fragment>
      ) : (
        title
      )}
    </React.Fragment>
  );
};

export default NotificationToastBody;
